import { Navigate, Outlet } from 'react-router-dom';
import FullLayout from '../layouts/FullLayout';
import { useAuth } from '../components/context/AuthContext';

const PrivateRoute = () => {
  const { accessToken, authReady } = useAuth();

  // Mientras no sepamos si hay token, no renderizamos nada
  if (!authReady) return null;

  // Si hay token, renderiza layout + rutas hijas,
  // si no, redirige al login
  return accessToken ? (
    <FullLayout>
      <Outlet />
    </FullLayout>
  ) : (
    <Navigate to="/auth/login" replace />
  );
};

export default PrivateRoute;
